import { useNavigate, useParams } from "react-router-dom";
import fetchData from "../../APIsControll/apiControll";
import { useAuth } from "../../components/context/Auth";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import styles from "../dashboard/Dispatch.module.css";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  formatDateTime,
  getStatusColor,
  handleViewImage,
} from "../../Utils/Utils";
import Button from "../../components/updatedComponents/Dealers/Button";
import {
  LeftArrow,
  ShareIcon,
  SideBarDeliveryIcon,
} from "../../components/icons/Icon";
import { ModalWrapper } from "../../exports";
import ShareLinkModal from "../../components/updatedComponents/OrderManager/ShareLinkModal";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import Slider from "./Slider";
import DeliveryDetailsModal from "./DeliveryDetailsModal";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";

const Newviewdispatchdetails = () => {
  const { mode, managerId, designations } = useAuth();

  const navigate = useNavigate();

  const { orderId, warehouseId } = useParams();

  const [orderData, setOrderData] = useState({});
  const [shippingInfo, setShippingInfo] = useState({});
  const [shippingAddress, setShippingAddress] = useState({});
  const [itemDetails, setItemDetails] = useState([]);
  const [packingImgs, setPackingImgs] = useState([]);
  const [deliveryPhotos, setDeliveryPhotos] = useState([]);
  const [deliveryVideos, setDeliveryVideos] = useState([]);
  const [paymentLink, setPaymentLink] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([]);
  const [warehouseName, setWarehouseName] = useState("");

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
      };
      const data = await fetchData("dispatch/order", apiData);

      if (data.status === "success") {
        setLoading(false);
        setOrderData(data.data.order);
        setShippingInfo(data.data.order.shippingInfo);
        setShippingAddress(data.data.order.shippingAddress);
        setItemDetails(
          data.data.order.items.map((d, i) => ({
            uri: d.thumbnail,
            header: `Item No.: ${d.itemNo}, Category: ${d.product_name}`,
            warehouse: d.warehouse,
            warehouseId: d.warehouseId,
          })),
        );
        setPartners(
          data?.data?.courierPartners?.filter((partner) =>
            partner?.selectedWarehouse?.some(
              (w) => w?.warehouseId === warehouseId,
            ),
          ),
        );

        const allSameWarehouse = data?.data?.order?.items?.every(
          (item, index, array) => item?.warehouseId === array[0]?.warehouseId,
        );

        const warehouseName =
          data?.data?.order?.shippingInfo?.find(
            (s) => s.warehouseId === warehouseId,
          )?.warehousename || "";

        setWarehouseName(warehouseName);

        setOrderData((prev) => ({
          ...prev,
          isNormalOrder: allSameWarehouse,
        }));
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [managerId, orderId, warehouseId]);

  const getMediaDetails = useCallback(async () => {
    try {
      setLoading(true);
      const apiData = {
        orderId: orderId,
        dealerId: orderData?.dealerId,
        warehouseId: warehouseId,
      };
      const data = await fetchData("deliveryPartner/courierSlipMedia", apiData);

      if (data.status === "success") {
        const foundObject = data?.data?.shippingInfo?.find(
          (w) => w.warehouseId === warehouseId,
        );

        setDeliveryPhotos(
          foundObject.deliveryPhoto.map((d, i) => ({
            uri: d.PhotoAndVideoUri,
            header: `Delivery Photo ${i + 1}`,
          })),
        );

        setDeliveryVideos(
          foundObject.deliveryVideo.map((d, i) => ({
            uri: d.PhotoAndVideoUri,
            header: `Delivery Video ${i + 1}`,
          })),
        );
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [orderData?.dealerId, orderId, warehouseId]);

  const generatePaymentLink = useCallback(
    async (oId) => {
      setPaymentLink("");
      const currentOrderId = oId || orderId;
      if (!currentOrderId) {
        return;
      }
      try {
        const apiData = { orderId: currentOrderId };
        const result = await fetchData("receipt/generatePaymentLink", apiData);
        if (result.status === "success" && result.shortUrl) {
          const link = `${result.shortUrl}`;
          setPaymentLink(link);
          return link;
        } else {
        }
      } catch (error) {}
    },
    [orderId],
  );

  useEffect(() => {
    if (!managerId || !orderId) return;
    getData();
    generatePaymentLink();
  }, [generatePaymentLink, getData, managerId, orderId]);

  useEffect(() => {
    if (!orderId || !orderData?.dealerId) return;
    getMediaDetails();
  }, [getMediaDetails, orderId, orderData?.dealerId]);

  const openModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const openDeliveryDetailsModal = () => {
    openModal(
      <DeliveryDetailsModal
        mode={mode}
        closeModal={closeModal}
        managerId={managerId}
        orderId={orderId}
        orderData={orderData}
        partners={partners}
        getData={getData}
        paymentLink={paymentLink}
        type={"update"}
        filteredShippingInfo={filteredShippingInfo}
        warehouseName={warehouseName}
        warehouseId={warehouseId}
        allPartners={partners}
        // isDispatchWarehouse={isDispatchWarehouse}
        // partner={partner}
      />,
    );
  };

  const openShareLinkModal = () => {
    openModal(
      <ShareLinkModal
        mode={mode}
        managerId={managerId}
        handleCloseModal={() => setIsModalOpen(false)}
        generatedLink={paymentLink}
        whatsappNo={orderData?.whatsapp}
        mobileNo={orderData?.mobile}
        email={orderData.email}
        isModalOpen={true}
      />,
    );
  };

  const canUpdateDispatchDetails =
    designations.includes("superadmin") ||
    designations.includes("dispatchmanager");

  const hideUpdateDeliveryDetails =
    orderData.dispatchStatus === "Completed" &&
    orderData.packingStatus === "Completed";

  const isCombined = orderData.shippingType === "Combined";

  const isNormalOrder = orderData.isNormalOrder;

  const filteredShippingInfo = useMemo(() => {
    if (!warehouseId || !Array.isArray(shippingInfo)) return [];
    return shippingInfo.filter((s) => s.warehouseId === warehouseId);
  }, [shippingInfo, warehouseId]);

  const filteredItemDetails = useMemo(() => {
    if (!warehouseId || !Array.isArray(itemDetails)) return itemDetails || [];
    return (itemDetails || []).filter((it) => it.warehouseId === warehouseId);
  }, [itemDetails, warehouseId]);

  useEffect(() => {
    setPackingImgs(
      filteredShippingInfo[0]?.packingImgs?.map((d, i) => ({
        uri: d,
        header: `Pack ${i + 1}`,
      })),
    );
  }, [filteredShippingInfo]);

  const routeName = "Dispatch Details / " + orderId;

  return (
    <div
      className={styles.dispatch}
      style={{
        backgroundColor: mode && "#2C2E33",
        borderColor: mode && "#2C2E33",
      }}
    >
      <ModalWrapper
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        noBtn
      >
        {modalContent}
      </ModalWrapper>

      <div className={styles.dispatch_top}>
        <div>
          <TopTabBar text={routeName} />
        </div>

        <div className={styles.dispatch_right}>
          <TextElement
            label={"Voucher No. & Date:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={
              orderData.orderId + " / " + formatDateTime(orderData.orderDate)
            }
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Created By:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={orderData.createdBy}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Order Manager:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={orderData.ordermanager || "In Dev."}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Status:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={filteredShippingInfo[0]?.dispatchStatus}
            valueColor={getStatusColor(filteredShippingInfo[0]?.dispatchStatus)}
            fontSize={"12px"}
            type={"order"}
          />
        </div>
      </div>

      <div className={styles.scroll_wrapper}>
        {loading ? (
          <div>
            <Skeleton
              lines={1}
              thickness={15}
              additionalStyles={{
                marginBottom: "0px",
                marginTop: "0px",
                borderRadius: "15px",
              }}
            />
          </div>
        ) : (
          <div
            className={styles.det_1}
            style={{
              backgroundColor: mode && "#1B1D21",
              borderColor: mode && "#1B1D21",
            }}
          >
            <div className={styles.det_1_sub}>
              <p
                style={{
                  color: mode && "#FFFFFF",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                {orderData.storeName} / {shippingAddress.name}
              </p>

              <div style={{ width: "300px" }}>
                <VerticalDropDown2
                  height={"37px"}
                  fontSize={"12px"}
                  dropDownText={"Select"}
                  value={{ label: warehouseName, value: warehouseId }}
                  backgroundColor={mode && "#232529"}
                  disableOpen={true}
                />
              </div>
            </div>

            <div className={styles.det_1_sub}>
              <div className={styles.det_1_sub_2}>
                <TextElement
                  label={"Address:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={
                    shippingAddress.street +
                    ", " +
                    shippingAddress.city +
                    ", " +
                    shippingAddress.district +
                    ", " +
                    shippingAddress.state +
                    ", " +
                    shippingAddress.pincode
                  }
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"Contact:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData.mobile}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"Email:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData.email}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"GSTUIN :"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={orderData.gstuin}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
              </div>

              <div className={styles.det_1_sub_2}>
                <TextElement
                  label={"Courier Name:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={filteredShippingInfo[0]?.courierName}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"Delivery Method:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={filteredShippingInfo[0]?.methodName}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"Shipping Type:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={isNormalOrder ? "Normal" : orderData?.shippingType}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"Dispatch Warehouse:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={
                    isCombined ? orderData?.dispatchWarehouse : warehouseName
                  }
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
                <TextElement
                  label={"Packer:"}
                  labelColor={mode ? "#fff" : "#646B88"}
                  value={filteredShippingInfo[0]?.packermanager}
                  valueColor={mode ? "#fff" : "#646B88"}
                  fontSize={"14px"}
                  fontWeight={"400"}
                />
              </div>
            </div>
          </div>
        )}

        {loading ? (
          <div>
            <Skeleton
              lines={1}
              thickness={30}
              additionalStyles={{
                marginBottom: "0px",
                marginTop: "0px",
                borderRadius: "15px",
              }}
            />
          </div>
        ) : (
          <div
            className={styles.sec_2}
            style={{
              backgroundColor: mode && "#1B1D21",
              borderColor: mode && "#1B1D21",
            }}
          >
            <div>
              <p style={{ color: mode && "#FFFFFF" }}>Delivery Slip</p>
              {/* {filteredShippingInfo[0]?.courierSlip && ( */}
              <div
                className={styles.image_view}
                onClick={() =>
                  handleViewImage(filteredShippingInfo[0]?.courierSlip)
                }
                style={{
                  borderColor: mode && "#7a7b7d",
                  visibility: filteredShippingInfo[0]?.courierSlip
                    ? "visible"
                    : "hidden",
                }}
              >
                <img
                  src={
                    filteredShippingInfo[0]?.courierSlip instanceof File
                      ? URL.createObjectURL(
                          filteredShippingInfo[0]?.courierSlip,
                        )
                      : `${process.env.REACT_APP_S3URL}${filteredShippingInfo[0]?.courierSlip}`
                  }
                  alt="Courier Slip Preview"
                  className={styles.file_preview}
                  loading="lazy"
                  style={{ color: mode && "#FFFFFF" }}
                />
              </div>
              {/* )} */}
            </div>

            <div className={styles.border_con_container}>
              <div>
                <p style={{ color: mode && "#FFFFFF" }}>Slip Details</p>
                <div
                  className={styles.border_con}
                  style={{ borderColor: mode && "#7a7b7d" }}
                >
                  <TextElement
                    label={"Uploaded By :"}
                    labelColor={mode ? "#fff" : "#646B88"}
                    value={filteredShippingInfo[0]?.slipUploadedBy}
                    valueColor={mode ? "#fff" : "#646B88"}
                    fontSize={"14px"}
                    fontWeight={"400"}
                  />
                  <TextElement
                    label={"Uploaded At :"}
                    labelColor={mode ? "#fff" : "#646B88"}
                    value={formatDateTime(
                      filteredShippingInfo[0]?.slipUploadTime,
                    )}
                    valueColor={mode ? "#fff" : "#646B88"}
                    fontSize={"14px"}
                    fontWeight={"400"}
                  />
                  <TextElement
                    label={"Designation :"}
                    labelColor={mode ? "#fff" : "#646B88"}
                    value={filteredShippingInfo[0]?.slipUploadByDesignation}
                    valueColor={mode ? "#fff" : "#646B88"}
                    fontSize={"14px"}
                    fontWeight={"400"}
                  />
                </div>
              </div>

              <div>
                <p style={{ color: mode && "#FFFFFF" }}>Delivery Details</p>
                <div
                  className={styles.border_con}
                  style={{ borderColor: mode && "#7a7b7d" }}
                >
                  <TextElement
                    label={"Partner Name :"}
                    labelColor={mode ? "#fff" : "#646B88"}
                    value={filteredShippingInfo[0]?.delPerName}
                    valueColor={mode ? "#fff" : "#646B88"}
                    fontSize={"14px"}
                    fontWeight={"400"}
                  />
                  <TextElement
                    label={"Mobile :"}
                    labelColor={mode ? "#fff" : "#646B88"}
                    value={filteredShippingInfo[0]?.delPerMobile}
                    valueColor={mode ? "#fff" : "#646B88"}
                    fontSize={"14px"}
                    fontWeight={"400"}
                  />
                  <div style={{ visibility: "hidden" }}>
                    <TextElement
                      label={"Date & Time:"}
                      fontSize={"14px"}
                      // labelColor={mode ? "#fff" : "#646B88"}
                      // value={formatDateTime(
                      //   filteredShippingInfo[0]?.slipUploadTime
                      // )}
                      // valueColor={mode ? "#fff" : "#646B88"}
                      // fontWeight={"400"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {loading ? (
          <div>
            <Skeleton
              lines={1}
              thickness={30}
              additionalStyles={{
                marginBottom: "0px",
                marginTop: "0px",
                borderRadius: "15px",
              }}
            />
          </div>
        ) : (
          <>
            <Slider mode={mode} data={packingImgs} type={"image"} />
          </>
        )}

        {loading ? (
          <div>
            <Skeleton
              lines={1}
              thickness={30}
              additionalStyles={{
                marginBottom: "0px",
                marginTop: "0px",
                borderRadius: "15px",
              }}
            />
          </div>
        ) : (
          <>
            <Slider mode={mode} data={filteredItemDetails} type={"image"} />
          </>
        )}

        {loading ? (
          <div>
            <Skeleton
              lines={1}
              thickness={30}
              additionalStyles={{
                marginBottom: "0px",
                marginTop: "0px",
                borderRadius: "15px",
              }}
            />
          </div>
        ) : (
          <Slider mode={mode} data={deliveryPhotos} type={"image"} />
        )}

        {loading ? (
          <div>
            <Skeleton
              lines={1}
              thickness={30}
              additionalStyles={{
                marginBottom: "0px",
                marginTop: "0px",
                borderRadius: "15px",
              }}
            />
          </div>
        ) : (
          <Slider mode={mode} data={deliveryVideos} type={"video"} />
        )}
      </div>

      <footer className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
        <div className={styles.btn_wrapper}>
          <div>
            <Button
              buttonIcon={<LeftArrow color={"#FFFFFF"} />}
              buttonText={"Back"}
              buttonBgColor={"#000000"}
              buttonTextColor={"#ffffff"}
              buttonClick={() => navigate(-1)}
            />
          </div>

          {!hideUpdateDeliveryDetails && canUpdateDispatchDetails && (
            <div>
              <Button
                buttonIcon={<SideBarDeliveryIcon color="#FFFFFF" />}
                buttonText={"Update Delivery Details"}
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonClick={openDeliveryDetailsModal}
              />
            </div>
          )}

          <div>
            <Button
              buttonIcon={<ShareIcon />}
              buttonText={"Share"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonClick={openShareLinkModal}
            />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Newviewdispatchdetails;
